// Main App Routes Configuration
import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '../theme/ThemeProvider';
import { DataProvider } from '../contexts/DataContext';
import { ChatProvider } from '../contexts/ChatContext';
import { AuthProvider } from '../auth/AuthContext';
import { NotificationProvider } from '../contexts/NotificationContext';
import { WebSocketProvider } from '../contexts/WebSocketContext';
// Public Landing
import LandingPage from '../pages/landing/LandingPage';
import SupportCenterLanding from '../pages/landing/SupportCenterLanding';
import SupportCenterLandingExact from '../pages/landing/SupportCenterLandingExact';
import SupportPortalLanding from '../pages/landing/SupportPortalLanding';
import PublicDashboard from '../pages/public/PublicDashboard';
import PrivacyPolicy from '../pages/public/PrivacyPolicy';

// Unified Home (Dynamic Menu)
import HomePage from '../pages/Home';

// Layouts
import PortalHomeLayout from '../layouts/PortalHomeLayout';
import AdminLayout from '../layouts/AdminLayout';
import AgentLayout from '../layouts/AgentLayout';
import DeveloperLayout from '../layouts/DeveloperLayout';
import SuperAdminLayout from '../layouts/SuperAdminLayout';
// Route Configurations
import { portalRoutes } from './PortalRoutes';
import { adminRoutes } from './AdminRoutes';
import { agentRoutes } from './AgentRoutes';
import { developerRoutes } from './DeveloperRoutes';
import { superAdminRoutes } from './SuperAdminRoutes';
import AutoLoginRedirect from '../pages/agent/tickets/AutoLoginRedirect';
import { AgentLiveChatProvider } from '../contexts/AgentLiveChatContext';

/** Agent chat global state + pending API only after login (Home shell), not on /signin landing. */
const HomeWithAgentLiveChat = () => (
  <AgentLiveChatProvider>
    <HomePage />
  </AgentLiveChatProvider>
);

export const AppRoutes = () => {
  return (
    <AuthProvider>
      <WebSocketProvider>
        <NotificationProvider>
          <ThemeProvider>
            <DataProvider>
              <ChatProvider>
                <Routes>
                {/* Public Routes */}
                <Route path="/" element={<LandingPage />} />
                <Route path="/landing" element={<LandingPage />} />
                <Route path="/dashboard" element={<PublicDashboard />} />
                <Route path="/public-dashboard" element={<PublicDashboard />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/signin" element={<LandingPage />} />
                <Route path="/login" element={<LandingPage />} />

                {/* Unified Home - Dynamic Menu System (Handles ALL authenticated routes) */}
                <Route path="/home" element={<HomeWithAgentLiveChat />} />
                <Route path="/home/*" element={<HomeWithAgentLiveChat />} />
                <Route path="/agent/tickets/newest" element={<AutoLoginRedirect />} />

                {/* Old versions for reference */}
                <Route path="/landing-old" element={<SupportCenterLanding />} />

                {/* NOTE: All authenticated routes now use HomePage with dynamic menus */}
                {/* Old static routes are bypassed - HomePage handles all routes dynamically */}
                
                {/* Catch-all: All routes (including /admin/*, /agent/*, etc.) use dynamic Home */}
                {/* HomePage will check if route exists in API menu, otherwise redirect to dashboard */}
                <Route path="*" element={<HomeWithAgentLiveChat />} />
                </Routes>
              </ChatProvider>
            </DataProvider>
          </ThemeProvider>
        </NotificationProvider>
      </WebSocketProvider>
    </AuthProvider>
  );
};

export default AppRoutes;
